import {useSetRecoilState} from 'recoil';
import {useQuery} from 'react-query';
import {ownDeclaration} from '../state/ownDeclaration';
import actions from '../api/ownDeclaration';

const twentyFourHoursInMs = 1000 * 60 * 60 * 24;

const useFetchOwnDeclaration = () => {
  const setOwnDeclaration = useSetRecoilState(ownDeclaration);
  return useQuery('fetchOwnDeclarations', async () => {
    const ownDeclaration = await actions.fetchOwnDeclaration();
    setOwnDeclaration(ownDeclaration?.data);
    return ownDeclaration;
  }, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: false,
    staleTime: twentyFourHoursInMs,
    enabled: false,
  });
};

export default useFetchOwnDeclaration;
